<script setup lang="ts">
import { ref } from "vue";
import { useRoute } from "vue-router";
import { RegistrationChannel } from "@/shared/@types/RegistrationChannel";
import { getQueryStringValue } from "@/shared/helper/getQueryStringValue.helper";
import fbsRegistrationImage from "@/shared/images/fbs-registration.webp";
import type { InitialRegistrationData } from "@/app/registration-app/user/shared/@types/InitialRegistrationData";
import { RegistrationSalutation } from "@/app/registration-app/user/shared/@types/RegistrationSalutation";
import RegistrationWizardContainer from "@/app/registration-app/user/shared/containers/RegistrationWizardContainer/RegistrationWizardContainer.vue";
import RequestInviteScreen from "@/app/registration-app/shared/components/RequestInviteScreen/RequestInviteScreen.vue";

// --- Query parameters to prefill form ---
const route = useRoute();
const initialData = ref<InitialRegistrationData | undefined>();

const buildInitialData = () => {
  const salutationValue = getQueryStringValue(route.query.salutation);
  const parsedSalutation = Object.values(RegistrationSalutation).find(
    (value) => value === salutationValue,
  );

  initialData.value = {
    customerNumber: getQueryStringValue(route.query.customer_number),
    invoiceNumber: getQueryStringValue(route.query.invoice_number),
    email: getQueryStringValue(route.query.email),
    salutation: parsedSalutation,
    firstName: getQueryStringValue(route.query.first_name),
    lastName: getQueryStringValue(route.query.last_name),
    phone: getQueryStringValue(route.query.phone),
  };
};

buildInitialData();

// --- Request Invite ---
const isRequestInviteVisible = ref(false);

const showRequestInvite = () => (isRequestInviteVisible.value = true);
const changeCustomerNumber = () => (isRequestInviteVisible.value = false);

// TODO: notify the responsible Account Managers once the process is defined
const requestInvite = () => {};
</script>

<template>
  <RequestInviteScreen
    v-if="isRequestInviteVisible"
    :image="fbsRegistrationImage"
    @request-invite="requestInvite"
    @change-customer-number="changeCustomerNumber"
  />
  <RegistrationWizardContainer
    v-else
    :title="$t('registration.user.fbsHub.title')"
    :text="$t('registration.user.fbsHub.text')"
    :channel="RegistrationChannel.Fbs"
    :image="fbsRegistrationImage"
    :initial-data="initialData"
    @request-invite="showRequestInvite"
  />
</template>
